import { useSession } from '../lib/session';
import { Button } from '../components/ui';

/**
 * Field users are gated out of the portal by design: everything they are
 * allowed to do happens on a job site, and every high-stakes action they might
 * reach for here needs an approval anyway.
 */
export default function MobileRequired() {
  const { contractor, signOut } = useSession();
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-6">
      <div className="max-w-md text-center">
        <p className="text-2xl font-extrabold tracking-tight text-ink">
          Lien<span className="text-tint">Guardian</span>
        </p>
        <h1 className="mt-6 text-xl font-bold text-ink">Mobile app required</h1>
        <p className="mt-3 text-sm leading-relaxed text-muted">
          {contractor?.companyName ?? 'Your company'} has you on a <strong className="text-ink">field</strong> seat.
          Field work runs in the LienGuardian mobile app — logging work, photographing the NOC, and requesting
          waivers or lien filings for the office to approve.
        </p>
        <p className="mt-3 text-sm text-muted">
          Need the web portal? Ask an admin on your account to move you to a manager seat.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Button variant="secondary" onClick={() => void signOut()}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
